export const subtitles = {
    "1": {
        "startTime": 3.8,
        "endTime": 12.45,
        "transcript": "Aren tua-i waniw' tuaten ayuqellruunga. Ava-i qanemcitamken.",
        "translation": "Oh my, I was like that. I just told you the story."
    },
    "2": {
        "startTime": 14.29,
        "endTime": 16.89,
        "transcript": "Ayagtukuk-qaa? Assiriuq?",
        "translation": "Are we going? Is it better?"
    },
    "3": {
        "startTime": 16.895,
        "endTime": 25.125,
        "transcript": "Kitak', kitak' makut wani assilriit qanernailnguut angalkuut canek calilallruat?",
        "translation": "So now, how did these good shamans that didn't needed to be scolded work?"
    },
    "4": {
        "startTime": 25.385,
        "endTime": 30.275,
        "transcript": "Yugnek tuunriskenglallruut assirivkaraqluki",
        "translation": "They would use their shamanistic powers on people to heal them"
    },
    "5": {
        "startTime": 30.355,
        "endTime": 37.255,
        "transcript": "Naulluulrianek-llu tuunriskengaqameng assirivkaraqluki camek iquaraunaki.",
        "translation": "And when they use their shamanistic powers on the sick to heal them without side effects."
    },
    "6": {
        "startTime": 37.645,
        "endTime": 42.815,
        "transcript": "Assirivkaraqluki cayugnairucelluki.",
        "translation": "They heal them so there was nothing left wrong with them."
    },
    "7": {
        "startTime": 43.475,
        "endTime": 52.61,
        "transcript": "Wani-llu qasgimi tuunriaqameng imkut umyuarrlulriit yuk tauna pillrulliniaqatgu",
        "translation": "And when they exercised their shamanistic powers in the community house on a person whom [others] had [attacked] with malice"
    },
    "8": {
        "startTime": 52.61,
        "endTime": 66.12,
        "transcript": "Angalkut ilait camek-wa catailnguq man' teguarkamek-llu catailnguq waten tua-i talliteng piqerluki cayuurata",
        "translation": "Some shamans, when they were faced with something invisible that they could take, when they did this with their arms and pulled what was invisible"
    },
    "9": {
        "startTime": 66.12,
        "endTime": 69.28,
        "transcript": "Cayuuqengarkailnguut-wa camek.",
        "translation": "Yet they had nothing [physical] to pull."
    },
    "10": {
        "startTime": 69.285,
        "endTime": 76.175,
        "transcript": "Cayuurata angalkut-ll' iliit taklainanermini makqetaaraqluni.",
        "translation": "As one of the shamans kept pulling, they'd get pulled up as they lay there."
    },
    "11": {
        "startTime": 76.855,
        "endTime": 84.795,
        "transcript": "Tua-i-gguq tauna taum naulluulriim naulluuvkartii",
        "translation": "They said that what had been making that sick person sick"
    },
    "12": {
        "startTime": 86.13,
        "endTime": 93.96,
        "transcript": "Tua-i qaillun meci'irviinateng uitalallruut tuaten pik'ngait.",
        "translation": "The ones that they did that to couldn't deny it happened as they were there."
    },
    "13": {
        "startTime": 94.74,
        "endTime": 100.58,
        "transcript": "Makqetaalalriit meci'irviinateng uitalallrulliniut.",
        "translation": "Those that were pulled up like that would stay without being able to deny that it had happened."
    },
    "14": {
        "startTime": 101.265,
        "endTime": 105.415,
        "transcript": "Qaillun-llu pillrunritniluku qanerviinateng.",
        "translation": "And they couldn't say that nothing had happened."
    },
    "15": {
        "startTime": 107.775,
        "endTime": 109.125,
        "transcript": "Tua-i.",
        "translation": "There you have it."
    },
    "16": {
        "startTime": 109.405,
        "endTime": 115.1,
        "transcript": "Tuaten tua-i yuut amlleret cali qinuciaratullruut.",
        "translation": "Many of those people would experience delirium before death like that."
    },
    "17": {
        "startTime": 115.1,
        "endTime": 121.75,
        "transcript": "Ilaita angalkut makut qanernaarailnguut tuunritaqamegteki-llu",
        "translation": "When some shamans who did not need apprehending exercised their shamanistic powers on them"
    },
    "18": {
        "startTime": 121.75,
        "endTime": 127.82,
        "transcript": "Au͡g'arilluki tuavet naivtaqluki umyuarrlulriamun angalkumun.",
        "translation": "They'd forgive them, confess them to those malicious shamans."
    },
    "19": {
        "startTime": 128.15,
        "endTime": 131.39,
        "transcript": "Tuaten tua-i ayuqellruut.",
        "translation": "That's what they were like."
    },
    "20": {
        "startTime": 131.395,
        "endTime": 135.615,
        "transcript": "Naivvluki, ellaitnun tunluki",
        "translation": "They would confess unto them"
    },
    "21": {
        "startTime": 135.66,
        "endTime": 148.99,
        "transcript": "Nalluatgun-llu wall'u maaggun tua-i naw'un tangrrumanrilngurkun tua-i ellaita tua-i atungaqluku tuaten umyuarrlullerteng.",
        "translation": "Without their knowledge, or with some unknown force, they'd experience their own malicious intent."
    },
    "22": {
        "startTime": 149.6,
        "endTime": 156.26,
        "transcript": "Ellaita tua-i ellaitnun tut'aqluni umyuarrlullrat.",
        "translation": "Their malicious intent would fall upon them."
    },
    "23": {
        "startTime": 156.265,
        "endTime": 159.315,
        "transcript": "Tuaten ayuqellruut.",
        "translation": "That's what they were like."
    },
    "24": {
        "startTime": 159.395,
        "endTime": 165.485,
        "transcript": "Tua-i qaqilluki-llu nallunritenrilkenka",
        "translation": "I haven't covered the entirety [about] I don't know"
    },
    "25": {
        "startTime": 165.485,
        "endTime": 170.115,
        "transcript": "Ilait tau͡gaam tua waten tua niigartetullruanka.",
        "translation": "But I used to hear about some of them like this."
    },
    "26": {
        "startTime": 170.115,
        "endTime": 182.305,
        "transcript": "Ii-i, kitak' ellangyugallerpeni imumi tayima, arcaqerluku una erneq tekilluku",
        "translation": "Okay, so when you were growing up back then, especially up to this day"
    },
    "27": {
        "startTime": 182.305,
        "endTime": 191.225,
        "transcript": "Qanruyun eneqak'ngan cali, cali umyuarpeni mistuluni uitalria qanrutkeqerru",
        "translation": "Traditional wisdom that you remember, please talk about one that is still clear in your mind"
    },
    "28": {
        "startTime": 193.35,
        "endTime": 200.61,
        "transcript": "Qanruyutet niitelalten imumi avani nasaurlullraullerpeni ciuliarpenek.",
        "translation": "The traditional wisdom you used to hear back from your elders back when you were a girl."
    },
    "29": {
        "startTime": 200.615,
        "endTime": 205.275,
        "transcript": "Atam, avani tang ciuqvaarni",
        "translation": "You see, a long time ago"
    },
    "30": {
        "startTime": 207.77,
        "endTime": 216.88,
        "transcript": "Qalarutestemta imkut qalarutetullrukaitkut tuar tang nunulriit.",
        "translation": "Our instructors back then would instruct us, and it seemed they were scolding."
    },
    "31": {
        "startTime": 217.59,
        "endTime": 228.54,
        "transcript": "Wangkurlumta niicugninaurtukut pekviirulluta aqumluta, kiiryungluta-llu, unateput-llu mecungengluteng.",
        "translation": "We poor people would listen, unable to move as we sat, getting hot, and our hands would get wet."
    },
    "32": {
        "startTime": 229.0,
        "endTime": 232.85,
        "transcript": "Pek'arrviirulluta qanrutaqatkut.",
        "translation": "We couldn't move anymore when they instructed us."
    },
    "33": {
        "startTime": 232.856,
        "endTime": 235.981,
        "transcript": "Waten imum aanama pitullruanga:",
        "translation": "This is what my mother used to say to me:"
    },
    "34": {
        "startTime": 236.0,
        "endTime": 244.5,
        "transcript": "\"Kitak' qanrutestevnek niiskuvet qanrutestevet qanra tangvakiu taqvianun.",
        "translation": "\"Now, when you hear someone instructing you, watch you instructor's mouth until [s]he stops."
    },
    "35": {
        "startTime": 244.507,
        "endTime": 252.069,
        "transcript": "\"Tuaten-llu pingalengraaten ulu'urteksaunaku taqvianun qanrakun tangvalaqiu.\"",
        "translation": "\"And though he seems to be directing at you, don't look away from them, and watch their mouth until they're done.\""
    },
    "36": {
        "startTime": 254.357,
        "endTime": 259.607,
        "transcript": "Tua-i alerquasteka call' aturluku tuatnalallruunga.",
        "translation": "I'd also follow what my instructor said and do that."
    },
    "37": {
        "startTime": 259.614,
        "endTime": 269.676,
        "transcript": "\"Nunurngalengraaten tangvaurqiu qanrakun. Taqkaten tau͡gaam nutaan ulurluku.\"",
        "translation": "\"Though [s]he seems to scold you, watch their mouth. Only when [s]he's done, look away.\""
    },
    "38": {
        "startTime": 269.689,
        "endTime": 272.552,
        "transcript": "Tuatnalallruunga.",
        "translation": "I would do that."
    },
    "39": {
        "startTime": 272.564,
        "endTime": 281.389,
        "transcript": "Ilumun tuatnatulleq yuk qanruyutellminek nalluyaguciyuitelliniuq.",
        "translation": "Truly, a person who was there should not forget the traditional wisdom passed down to them."
    },
    "40": {
        "startTime": 281.42,
        "endTime": 286.095,
        "transcript": "Maa-i pekviirulluta niicugnilalluukut.",
        "translation": "We'd listen without being able to move."
    },
    "41": {
        "startTime": 286.101,
        "endTime": 297.001,
        "transcript": "Taqkacagaakut tau͡gaam taum qanrucilriim nutaan tua-i nangerrluta tua-i unitaqluku.",
        "translation": "Only when they they were done, that instructor, would we stand and leave them."
    },
    "42": {
        "startTime": 297.02,
        "endTime": 305.22,
        "transcript": "Taqeqapiariikut tau͡gaam unilluku nangertaqluku, taqeqaqakut tau͡gaam.",
        "translation": "Only when [s]he finished with us, we'd stand away from them, only when [s]he finished with us."
    },
    "43": {
        "startTime": 305.227,
        "endTime": 314.814,
        "transcript": "Nunurnganata niicugninauput. Nekanaqnganateng, nunurnganateng pinaurtut.",
        "translation": "We'd listen as they seemed to scold us. They'd seem to offend us, scold us."
    },
    "44": {
        "startTime": 315.102,
        "endTime": 323.564,
        "transcript": "Aren, maa-i tang ayuqucirtuutellrit tailait. Tekitaqamki elitaq'laqenka.",
        "translation": "Oh my, I wish their traditional instructions would come. When I come upon them, I recognize them."
    },
    "45": {
        "startTime": 323.577,
        "endTime": 326.752,
        "transcript": "Elitaqaqluku ca tamalkuan.",
        "translation": "I'd recognize everything."
    },
    "46": {
        "startTime": 326.771,
        "endTime": 334.096,
        "transcript": "Elitaqa'artaqluku imna qanerturalriit qanrutkvakalallrita ilait.",
        "translation": "I'd so recognize what some instructors would speak of."
    },
    "47": {
        "startTime": 334.102,
        "endTime": 338.027,
        "transcript": "Caugat tamakut wani ilait qanruyutet?",
        "translation": "What are some of those pieces of traditional wisdom?"
    },
    "48": {
        "startTime": 338.046,
        "endTime": 342.558,
        "transcript": "Pulengtaarturluteng-llu qanrut'lallruitkut.",
        "translation": "They'd also tell us repeatedly"
    },
    "49": {
        "startTime": 342.571,
        "endTime": 349.759,
        "transcript": "Imna qanruyutellerteng egmirrluku cali pulenglluku call' qanrutkaqluku",
        "translation": "They'd also repeatedly tell that piece of traditional wisdom"
    },
    "50": {
        "startTime": 349.772,
        "endTime": 359.572,
        "transcript": "Pulengtaarluku, ataucirqumek niicetevkenaku tau͡gaam pulengtaarturluku niicetaqluku.",
        "translation": "Repeatedly, not letting them hear it once, but having them hear it repeatedly."
    },
    "51": {
        "startTime": 359.579,
        "endTime": 369.954,
        "transcript": "Aren, tua-i ilumun piciulriamek qanlallrulliniut au͡gkut ciuqliit yuut tua-i.",
        "translation": "Oh my, the first people back then would speak of true things."
    },
    "52": {
        "startTime": 369.973,
        "endTime": 383.91,
        "transcript": "Taumek cali imna makunek call' maa-i waten-llu imkulrianek, makunek-wa qaneryariurteńek ilaitnek Yugnek",
        "translation": "That's why when some of these people, when these Yupiit speak on the Bible"
    },
    "53": {
        "startTime": 383.923,
        "endTime": 391.51,
        "transcript": "Au͡g'na-llu ciuqliq atuyunairutniluku qanelrianek niitaqama",
        "translation": "And when I hear that the first doesnt need to be anymore"
    },
    "54": {
        "startTime": 391.523,
        "endTime": 401.26,
        "transcript": "Wall'u au͡gna ciuqliq atuyunairutniluku qanelrianek niitaqama waten umyuarteq'lalrianga",
        "translation": "Or when I hear people say the first shouldn't be done, I think like this"
    },
    "55": {
        "startTime": 401.273,
        "endTime": 407.535,
        "transcript": "Umyuaqeqalaqka Jesus-aaq waten qanellra:",
        "translation": "I think of the fact that Jesus said this:"
    },
    "56": {
        "startTime": 409.773,
        "endTime": 422.486,
        "transcript": "\"Wiinga waniwa Qaneryaraq alerquun piunrirrluku tekitenritua, tau͡gaam qaqicarturluku.",
        "translation": "\"I didn't come to destroy the Law, but to complete it."
    },
    "57": {
        "startTime": 423.173,
        "endTime": 434.723,
        "transcript": "\"Carraungraan man'a ciuqlirtaq inerquutellrunirtua watqapik tau͡gaa qaqicarturluku.\" Qanrutkellrua.",
        "translation": "\"I didn't come to destroy a single part of it, but to complete it.\" That's what he said."
    },
    "58": {
        "startTime": 434.73,
        "endTime": 442.792,
        "transcript": "Tua-i umyuaqellagturatuaqa waniwa waten qanellra uum Jesus-aam.",
        "translation": "I always remember this, that Jesus said."
    },
    "59": {
        "startTime": 443.118,
        "endTime": 450.43,
        "transcript": "Tua-i waniw', waniwa tang waniw' elliama",
        "translation": "So now, as I'm now this age"
    },
    "60": {
        "startTime": 450.443,
        "endTime": 461.518,
        "transcript": "Imkut qanruyutek'lallrenka tekitaqamki tua-i, yugnek-llu elitaqiaqama",
        "translation": "When I come across that traditional wisdom, and when I recognize people"
    },
    "61": {
        "startTime": 461.537,
        "endTime": 470.699,
        "transcript": "Imkut qanerturallrit qanrit tua-i elitaqa'arrnaunka qanlallrit.",
        "translation": "I would recognize what those instructrs would say."
    },
    "62": {
        "startTime": 470.712,
        "endTime": 485.462,
        "transcript": "Yuk-llu tauna tuaten qaillun ayuqeciqnilallrat tekitaqan tua-i imna qanrutkumalria tua-i eneqaqa'aqluku qaillun ayuqeciqnilallrat.",
        "translation": "And when that person that they said would end up a certain way, when the time time, I'd remember what they said about what they'd be like."
    },
    "63": {
        "startTime": 486.456,
        "endTime": 489.706,
        "transcript": "Tua-i ayuqelallruut.",
        "translation": "They were like that."
    },
    "64": {
        "startTime": 489.713,
        "endTime": 502.525,
        "transcript": "Tuamta-llu waniw' qanrusnginanrani qalarusnginanrani-llu yuut iliit nasaurluullgutenka-ll' iliit anngan avavialaraa.",
        "translation": "Then as they're speaking and instructing them, when one person, and when one of my fellow girls went out, they'd [?decry] her."
    },
    "65": {
        "startTime": 502.651,
        "endTime": 507.951,
        "transcript": "\"Alingnaqvaa tanem au͡g'umi. Ciin tanem au͡gna an'a?",
        "translation": "\"Oh my goodness that one. Why did they go out?"
    },
    "66": {
        "startTime": 508.108,
        "endTime": 519.045,
        "transcript": "\"Niicugniyuumiilami-wa tua-i ava-i anllilria elliin umyuani assikek'ni aturturluku yuunaluni.",
        "translation": "\"They probably went out since they didn't want to listen in order to live with whatever whims they have."
    },
    "67": {
        "startTime": 519.058,
        "endTime": 525.42,
        "transcript": "\"Assikek'ngani tekiskuniu yuvrirciqaa ellminek.\"",
        "translation": "\"When they come across what they liked, they'll examine it for themselves.\""
    },
    "68": {
        "startTime": 526.858,
        "endTime": 529.908,
        "transcript": "Waten qanrutkaqluku.",
        "translation": "They'd talk about them like that."
    },
    "69": {
        "startTime": 532.502,
        "endTime": 537.727,
        "transcript": "Assikek'ngaa tangerqaku elliinek tangerciqniluni.",
        "translation": "When they see what they liked, they'll see themself."
    },
    "70": {
        "startTime": 539.171,
        "endTime": 542.046,
        "transcript": "Tua-i waten pinauraat.",
        "translation": "They'd say this about them."
    },
    "71": {
        "startTime": 544.852,
        "endTime": 553.577,
        "transcript": "Tua-i alerquutet au͡gkut ciuqliit assiilnguunritqapiartut.",
        "translation": "Those first traditional instructions are absolutely not bad."
    },
    "72": {
        "startTime": 553.596,
        "endTime": 559.433,
        "transcript": "Taumek aturtellrit imkut yuunertuluteng-llu yuullrulriit.",
        "translation": "That's why the people who practiced them long ago lived long lives."
    },
    "73": {
        "startTime": 559.858,
        "endTime": 568.333,
        "transcript": "Pekcetaqaceteng-llu enruara'urluit cingqurruaqluteng. Tua-i-gguq enemeggnek yuuluteng.",
        "translation": "And when they moved them, their old bones would pop. They said they went out of [socket]."
    },
    "74": {
        "startTime": 568.339,
        "endTime": 573.439,
        "transcript": "Wall' tegulautengqelallruut-llu tuntunek curuitnek.",
        "translation": "Or, they also carried them on caribou antlers."
    },
    "75": {
        "startTime": 573.796,
        "endTime": 583.558,
        "transcript": "Cingqurrunaurtut. Tuamtellu enekaanun uitallerkaanun elliatni enruara'urlui tuar imkut nut'galalriit.",
        "translation": "They'd pop. Then when they put them where they were going to be, their old bones would be like shooting guns."
    },
    "76": {
        "startTime": 583.571,
        "endTime": 586.996,
        "transcript": "Tua-i-gguq enemeggnun ekluteng.",
        "translation": "They said they went back into place."
    },
    "77": {
        "startTime": 587.377,
        "endTime": 589.415,
        "transcript": "Tangerrluku.",
        "translation": "You see?"
    },
    "78": {
        "startTime": 589.428,
        "endTime": 597.29,
        "transcript": "Ugaani uum yuuyaraq cupuirluku, unguvayaraq cupuirluku.",
        "translation": "From being so [?tightly clung] to life, [?tightly clung] to being alive."
    },
    "79": {
        "startTime": 597.303,
        "endTime": 600.978,
        "transcript": "Ilait-llu-gguq keggutengnaurtut.",
        "translation": "And they said some grew a new set of teeth."
    },
    "80": {
        "startTime": 600.997,
        "endTime": 609.034,
        "transcript": "Keggukarangelrianek tamakut pinaurait. Tuarpiaq-gguq keggutait imarmiucinraat.",
        "translation": "They'd call them \"those with small new teeth.\" They said they looked like mink teeth."
    },
    "81": {
        "startTime": 609.047,
        "endTime": 612.822,
        "transcript": "Tua-i-gguq keggukarangelriit.",
        "translation": "They said those were \"those with small new teeth.\""
    },
    "82": {
        "startTime": 613.128,
        "endTime": 618.516,
        "transcript": "Tua-i atak' wiinga-llu-tuq waniw' keggukaranglii keggutairutellrianga.",
        "translation": "Well, I wish I could get small new teeth since I have no more."
    },
    "83": {
        "startTime": 620.591,
        "endTime": 623.266,
        "transcript": "Keggutairuqaarluteng-qaa tamakunek...",
        "translation": "Were those after they lost their teeth..."
    },
    "84": {
        "startTime": 623.285,
        "endTime": 627.872,
        "transcript": "Keggutairuqaarluteng tamakunek cimingaqluteng.",
        "translation": "After they lost their teeth, they'd be replaced by those."
    },
    "85": {
        "startTime": 627.897,
        "endTime": 633.872,
        "transcript": "Aren, wiinga'urluq tang waniw' au͡g'utun ayagyuallemtun ellilrianga",
        "translation": "Oh poor me, I've become like when I was young"
    },
    "86": {
        "startTime": 633.878,
        "endTime": 638.353,
        "transcript": "Ilngircetaqlua kegguteka una arulangaqan.",
        "translation": "I'd have my tooth removed when it gets loose."
    },
    "87": {
        "startTime": 638.372,
        "endTime": 647.484,
        "transcript": "Waniwa-llu qavcin ukut arulalriit pingayun, arulangelriit.",
        "translation": "Or, several of these, three, are starting to get loose."
    },
    "88": {
        "startTime": 647.885,
        "endTime": 663.085,
        "transcript": "Tua-i man'a-llu qulirneq keggutailnguq, keggutairutellria atauciq wani keggutnguara, tuamta-ll' man'a ukalirneq keggutairulluni, malruk-wa ukuk keggutek.",
        "translation": "Then here on the top has no tooth, one without a tooth has a false tooth here, then this part has no more teeh, and two teeth here."
    },
    "89": {
        "startTime": 663.092,
        "endTime": 672.742,
        "transcript": "Man'a-llu atlirneq, kanani-w' qukami atauciq keggun, ukut-wa tang qavcirraan waniwa uatiini.",
        "translation": "And the bottom here, there's one tooth down in the middle, and several teeth out from there."
    },
    "90": {
        "startTime": 672.761,
        "endTime": 679.461,
        "transcript": "Akia tau͡gken man'a atlirneq man'a cali ilangarteksailnguaqtarluteng.",
        "translation": "The other side, however, on the bottom hasn't lost any."
    },
    "91": {
        "startTime": 679.555,
        "endTime": 688.105,
        "transcript": "Tamakut-qaa yuunertullret ava-i qanelriaten cingqurruaqluteng enrit.",
        "translation": "Those people who lived long, you just said their bones would pop."
    },
    "92": {
        "startTime": 688.118,
        "endTime": 692.593,
        "transcript": "(Yuunialallruut-qaa aknirqelluteng?) Yuuniarayuunateng.",
        "translation": "(Would they complain of aches?) They wouldn't complain."
    },
    "93": {
        "startTime": 692.612,
        "endTime": 696.912,
        "transcript": "Akngirrngalnge'rmeng yuuniarayuunateng.",
        "translation": "Though they seemed in pain, they wouldn't complain."
    },
    "94": {
        "startTime": 697.094,
        "endTime": 703.494,
        "transcript": "Akekatakiirayuunateng tua-i akngirrngalnge'rmeng pinaurtut.",
        "translation": "They wouldn't go \"ouch\" though they seemed in pain."
    },
    "95": {
        "startTime": 703.501,
        "endTime": 707.288,
        "transcript": "Enrit-wa cingqurrulriit tuar nut'galalriit.",
        "translation": "Their bones would pop like guns firing."
    },
    "96": {
        "startTime": 707.401,
        "endTime": 713.001,
        "transcript": "Elliaqaceteng-llu tua-i mengqullagangnaurtut.",
        "translation": "And when they put them down, they'd make loud noises."
    },
    "97": {
        "startTime": 713.02,
        "endTime": 719.908,
        "transcript": "Tua-i-gguq enemeggnun ekluteng iquit yuullermeggnek.",
        "translation": "They said their joints would go back in from where they came out."
    },
    "98": {
        "startTime": 720.758,
        "endTime": 736.596,
        "transcript": "Aren wangkuta-ll' au͡gna maurlurlurput akleng tua-i upakatarluta-ll' pekcetaqateng curuanek tuntumek tegulaucirluku tua-i tuatnalalria tua-i.",
        "translation": "Oh my, and our dear grandmother, poor thing, when we were going to move and they moved her from her mat with caribou antlers, she would do that."
    },
    "99": {
        "startTime": 736.771,
        "endTime": 745.271,
        "transcript": "Ayaulluku-llu kevekluku uitallerkaanun tuavet elliatni acia maqaqluku",
        "translation": "And when they carried her and put her where she was going to be with a warm bed"
    },
    "100": {
        "startTime": 745.278,
        "endTime": 752.078,
        "transcript": "Tua-i call' enruara'urlui cingqurruluteng enemeggnun-gguq ekluteng.",
        "translation": "Her old bones would pop in what they said they were going back in place."
    },
    "101": {
        "startTime": 755.272,
        "endTime": 762.122,
        "transcript": "Tauna tua qanemcit'lallruakut cali taum maurlumta ayuqucillminek.",
        "translation": "Our grandmother would also tell us stories of what she was like."
    },
    "102": {
        "startTime": 765.004,
        "endTime": 773.441,
        "transcript": "Uingyaaqellruuq-gguq taumek angutet iliitnek, angalkumek-llu-gguq aprumaluni.",
        "translation": "She said she had taken one of the men as a husband, and he was called a shaman."
    },
    "103": {
        "startTime": 774.291,
        "endTime": 780.391,
        "transcript": "Uini-gguq tua-i tauna murilkellrunritaa.",
        "translation": "She said she didn't pay attention to her husband."
    },
    "104": {
        "startTime": 780.685,
        "endTime": 787.623,
        "transcript": "Tua-i canianun-llu-gguq inarcuunani, itraqan-llu-gguq unugmi unitaqluku.",
        "translation": "She said she wouldn't sleep by him, and would go out when he came in at night."
    },
    "105": {
        "startTime": 788.161,
        "endTime": 793.511,
        "transcript": "Tua-i caqerluku taum tua-i uingan unitellinikii.",
        "translation": "One day, her husband left her."
    },
    "106": {
        "startTime": 793.518,
        "endTime": 799.255,
        "transcript": "Nuliqsugyaaqeng'e'rmiu-gguq uniteqatarluku uptellria.",
        "translation": "She said though he wanted her as a wife, he was preparing to leave her."
    },
    "107": {
        "startTime": 800.468,
        "endTime": 804.53,
        "transcript": "Tua-i unitellran kinguani...",
        "translation": "After he left."
    },
    "108": {
        "startTime": 804.543,
        "endTime": 812.756,
        "transcript": "Keggani kegga-i qakmani Cakcaarmiunek-qaa niitetuuten Qaluyaat ukatiitni?",
        "translation": "Do you hear about Cakcaarmiut out there on this side of Qaluyaat?"
    },
    "109": {
        "startTime": 812.881,
        "endTime": 819.118,
        "transcript": "Cakcaarmiunek ingrit ukatmun iquitni.",
        "translation": "Cakcaarmiut, at this end of the mountains."
    },
    "110": {
        "startTime": 819.631,
        "endTime": 824.768,
        "transcript": "Atam tuani tua-i uinguangyaaqellinilria.",
        "translation": "You see, she found a lover there."
    },
    "111": {
        "startTime": 824.918,
        "endTime": 830.143,
        "transcript": "Uinguangyaaqluni allam au͡g'um tekilluku angutem.",
        "translation": "She found a lover when another man came upon her."
    },
    "112": {
        "startTime": 830.224,
        "endTime": 836.924,
        "transcript": "Angutem-gguq assipiam Alaskam iluani ayuqailnguum.",
        "translation": "She said he was a very handsome man with no equal in Alaska."
    },
    "113": {
        "startTime": 838.993,
        "endTime": 847.206,
        "transcript": "Tua-i elliin-llu assikngamiu ingluliurluku yuk tauna nukalpiaq assilria.",
        "translation": "And since she liked him, she was with that person in his prime."
    },
    "114": {
        "startTime": 848.456,
        "endTime": 856.093,
        "transcript": "Akleng maaten-gguq tang imna caqerluku tua-i, caqerluni-am payugtelliniluni tua-i.",
        "translation": "Poor thing, she said that one day, one day she was bringing food gifts to people."
    },
    "115": {
        "startTime": 856.106,
        "endTime": 863.768,
        "transcript": "Payugtarkani-gguq amllerrata qantat atliat tegumiaqaqaa, makut-wa-gguq tua-i qalliqluteng wavet.",
        "translation": "She said that since she had many food gifts, she held the bottom bowl, and these were on each other up to here."
    },
    "116": {
        "startTime": 864.106,
        "endTime": 868.544,
        "transcript": "Tua-i igcecaaqevkenaki-gguq tua-i payugtaquq.",
        "translation": "She said she tried not to let them fall as she gave food gifts."
    },
    "117": {
        "startTime": 868.557,
        "endTime": 878.457,
        "transcript": "Tua-i-ll' nugluni tua-i qantaqestaitnun aruqutkerraarluki aqumluni utaqalgirraarluni anluni.",
        "translation": "Then she came up, after giving them out to the owners of the bowls, after sitting and waiting, went out."
    },
    "118": {
        "startTime": 878.801,
        "endTime": 888.614,
        "transcript": "Anluni. Tua-i-gguq-am caqerluni tuatnarraarluni an'uq, aren tuarpiaq-gguq tang im' ella tanqigpapiaq.",
        "translation": "She went out. She said that after doing that, she went out, oh my, it seemed the world was so bright."
    },
    "119": {
        "startTime": 888.626,
        "endTime": 893.539,
        "transcript": "Iralirluni tanqigceńani cakneq.",
        "translation": "The moon was shining and it was very bright."
    },
    "120": {
        "startTime": 893.651,
        "endTime": 901.576,
        "transcript": "Aren, maaten-gguq tang qasgim amiiganek caqirrluni ukatmun piqertuq",
        "translation": "Oh my, she said that when she turned from the door of the community house, she realized"
    },
    "121": {
        "startTime": 901.882,
        "endTime": 909.557,
        "transcript": "Aqvaqatarniluku-gguq taum aipaq'lallran qanrut'lallrua.",
        "translation": "She said her old partner would tell her that he was going to get her."
    },
    "122": {
        "startTime": 909.563,
        "endTime": 913.638,
        "transcript": "Aqvaniararniluku.",
        "translation": "He said he was about to get there."
    },
    "123": {
        "startTime": 914.088,
        "endTime": 921.438,
        "transcript": "Un'a-gguq kan'a uatiit cikuyuitaa tua-i nengla qangqungraan.",
        "translation": "She said that the area downriver down there doesn't freeze though it's so cold it crunches."
    },
    "124": {
        "startTime": 921.832,
        "endTime": 929.182,
        "transcript": "Aren, qayaa qayakegtaar kan'a culungqaqalria [?].",
        "translation": "Oh my, his kayak, a nice kayak down there was docked."
    },
    "125": {
        "startTime": 929.526,
        "endTime": 937.351,
        "transcript": "Tangerqaani-llu anguarutni nalugluku arulaarrluku taisqelluku.",
        "translation": "When she saw him, he waved his oar to signal for her to come."
    },
    "126": {
        "startTime": 937.77,
        "endTime": 944.107,
        "transcript": "Tua-i-gguq-am kiingan ellakeqerluku tua-i aq'velria tua-i.",
        "translation": "She said he was all that was in her mind when she ran."
    },
    "127": {
        "startTime": 944.12,
        "endTime": 949.832,
        "transcript": "Acini-gguq tuar tuc'ungaqamiu tut'elaqii aqvaqullermini.",
        "translation": "She said it seemed her feet touched the ground in slow motion as she ran."
    },
    "128": {
        "startTime": 950.22,
        "endTime": 958.795,
        "transcript": "Tua-i-ll' waniw' tekitniararluku pamaken kingunranek nepa pamna aaralria.",
        "translation": "Then as she was going to reach him, there was the sound of someone screaming behind."
    },
    "129": {
        "startTime": 959.976,
        "endTime": 970.914,
        "transcript": "Arenqia, ayuqucini-gguq-am man' calriin ellanga'rtuq qetqallallinilria tua-i.",
        "translation": "My goodness, she said when she came to her senses, she realized that she had fallen on her back."
    },
    "130": {
        "startTime": 971.202,
        "endTime": 974.952,
        "transcript": "Qetqalliimi waniw' qetqallalliniluni.",
        "translation": "When she fell on her back, she was on her back."
    },
    "131": {
        "startTime": 974.971,
        "endTime": 980.671,
        "transcript": "Maaten-gguq im' tua qayaq eneqaqaamiu wavet tangerqeryaaqaa yaavet",
        "translation": "She said she realized as she remembered the kayak and looked over there"
    },
    "132": {
        "startTime": 980.765,
        "endTime": 989.378,
        "transcript": "Tauna-gguq cikuilqun uuqacuayaaqerluku waniw' qetqallallrullinilria. Qayaq im' tayima.",
        "translation": "She said that she fell on her back [?right before] the iceless area. The kayak was gone."
    },
    "133": {
        "startTime": 992.39,
        "endTime": 1006.103,
        "transcript": "Catailan nutaan nangerrluni ellani man' evcugluku pirraarluni nunat pikavet tangllinii yuk pikna eniita elatiini.",
        "translation": "Since it was gone, she stood up, after shaking herself to her senses, she look up and saw a person outside their house."
    },
    "134": {
        "startTime": 1006.528,
        "endTime": 1010.478,
        "transcript": "Tua-i nutaan tag'urallinilria.",
        "translation": "That was when she went up."
    },
    "135": {
        "startTime": 1010.597,
        "endTime": 1018.897,
        "transcript": "Aren, tagnginanermini-gguq ata tang imkut qantat tegumiallni eneqangkiliki.",
        "translation": "Oh my, she said as she was going up that she remembered the bowls she was holding."
    },
    "136": {
        "startTime": 1018.901,
        "endTime": 1025.101,
        "transcript": "\"Aren, imkuskiq qantarugaat tegumiallrenka natmun tayim' piniarcia?\"",
        "translation": "\"Oh my, I wonder where I put those many bowls I was holding?\""
    },
    "137": {
        "startTime": 1025.42,
        "endTime": 1040.283,
        "transcript": "Aren, maaten-gguq tua-i yuk tauna tekitevkenaku, qasgim elatiinek taun' qayaq tangellruamiu tamaavet ellillruyukluki qantat.",
        "translation": "Oh my, she said that she didn't go to that person, but since she say the kayak outside the community house, she thought she'd put them there."
    },
    "138": {
        "startTime": 1040.683,
        "endTime": 1046.333,
        "transcript": "Ullagluki, tua-i-llu-gguq yuum taum pia, \"Waqaa? Natmun ayagcit? Tai-tai.\"",
        "translation": "She went them, then that person said to her, \"What's wrong? Where're you going? Come here.\""
    },
    "139": {
        "startTime": 1046.34,
        "endTime": 1050.79,
        "transcript": "\"Uitaqaa, qantat imkut paqteqataranka.\"",
        "translation": "\"Wait, I'm going to check on those bowls.\""
    },
    "140": {
        "startTime": 1050.997,
        "endTime": 1059.447,
        "transcript": "Aren, tekicaaqaa-gguq tua-i tauna tangerrvillni taumek qayamek qantartaunani man' qasgim elatii.",
        "translation": "Oh my, she said that she reached the place where she saw the kayak and there was no bowls outside the community house."
    },
    "141": {
        "startTime": 1059.454,
        "endTime": 1068.916,
        "transcript": "Aren, avatiit-gguq man'a elaqvaq kiarrluku cat qagkut tunguuralriit tua-i pavani keluqvani elaqvani.",
        "translation": "Oh me, she said she looked around them to see some black things far inland out there."
    },
    "142": {
        "startTime": 1069.154,
        "endTime": 1077.254,
        "transcript": "Maaten-gguq ata tang im' ullagluki pii qantat imkut tegumiaqellni, nerkuamek-llu-gguq imaunateng.",
        "translation": "She said that she went to them to find the bowls she was holding, and they had not a scrap in them."
    },
    "143": {
        "startTime": 1079.473,
        "endTime": 1085.548,
        "transcript": "Aren, tua-i-gguq-am avuqiliki, naangata tau͡gaam tua-i taqluki.",
        "translation": "Oh my, she said she gathered, and only stopped when they were all there."
    },
    "144": {
        "startTime": 1085.667,
        "endTime": 1089.854,
        "transcript": "Egtellrullinikai-gguq-am tua-i yav'anun.",
        "translation": "She said she'd apparently threw them far away."
    },
    "145": {
        "startTime": 1089.867,
        "endTime": 1095.854,
        "transcript": "Aren, tua-i-gguq tuana nutaan yuk ullagluku tua-i itrulluku.",
        "translation": "Oh my, she said she went to that person and they brought her in."
    },
    "146": {
        "startTime": 1095.867,
        "endTime": 1105.704,
        "transcript": "Itrucamiu tua-i itrucaku taukut enem yuin [?check]-arutelliniluku tauna imna nasaurlurluq",
        "translation": "When she brought them in, when the people of that house brought them in, they had that girl [?check]"
    },
    "147": {
        "startTime": 1107.004,
        "endTime": 1112.942,
        "transcript": "Qaillun pilria cikuilnguum tungiinun aqvaquryaaqucianek.",
        "translation": "Why someone ran toward the water without ice."
    },
    "148": {
        "startTime": 1113.717,
        "endTime": 1124.967,
        "transcript": "\"Qayam-wa au͡g'um taisqeńgani nuluraani angurutni kevegluku atraqercaaqellrulria.\"",
        "translation": "\"Because someone on a kayak was waving his oar as a signal to come, she went down.\""
    },
    "149": {
        "startTime": 1124.986,
        "endTime": 1136.799,
        "transcript": "Tamaani-llu-gguq tang tua-i caqatarluni kepuriqatarluni-ll' napanek qagna napalian anlaryaaqellrulria.",
        "translation": "At the time, she said that she would go out to do things, including cut trees because there's a lot of trees out there."
    },
    "150": {
        "startTime": 1136.811,
        "endTime": 1142.811,
        "transcript": "Anenaurtuq-gguq kepurarugaat ukut ak'a taqellrullinilriit.",
        "translation": "She said she went out to find cut [branches] already finished."
    },
    "151": {
        "startTime": 1142.818,
        "endTime": 1146.18,
        "transcript": "Iterquiluni-gguq tau͡gken.",
        "translation": "However, she said she hauled water."
    },
    "152": {
        "startTime": 1146.193,
        "endTime": 1151.781,
        "transcript": "Tuamta-llu-gguq taukunek canek ciqluarqesqeńgatni elagyamun",
        "translation": "Then since they told her to store things into an underground ice cache"
    },
    "153": {
        "startTime": 1151.794,
        "endTime": 1159.006,
        "transcript": "Anenaurtuq-gguq ak'a tauna imkunek pisqutaitnek imangelliniaqelria.",
        "translation": "She said she'd go out and it would be filled with what they asked for."
    },
    "154": {
        "startTime": 1159.457,
        "endTime": 1170.182,
        "transcript": "Cunawa-gguq tua-i taum tekitaartii imiraqluki tua-i aqvavailgaki taukut pisqutait enem yui.",
        "translation": "She said it turned out that it was the who'd come to her who'd fill them with what the people of the house asked for before she got them."
    },
    "155": {
        "startTime": 1170.326,
        "endTime": 1172.976,
        "transcript": "Aren.",
        "translation": "Oh my."
    },
    "156": {
        "startTime": 1175.658,
        "endTime": 1186.62,
        "transcript": "Apqallinikiit tua-i atam ukut wani tuunritqataqallinikiit qasgimi.",
        "translation": "They mentioned that they were going to perform a shamanistic ritual on someone at the community house."
    },
    "157": {
        "startTime": 1187.071,
        "endTime": 1196.083,
        "transcript": "Tuani-gguq taum apqiita An'arissuutem tuunritlermini-gguq qanrutkellrua.",
        "translation": "She said that when the one called An'arissuun performed the ritual, he talked about it."
    },
    "158": {
        "startTime": 1196.096,
        "endTime": 1207.359,
        "transcript": "\"Akleng-gguq tuarpiaq-gguq waniw' nasaurluum uum acia avelngaat nuniit, ugnaraat.\"",
        "translation": "\"Poor thing, the girls' bedding truly looks like a vole nest.\""
    },
    "159": {
        "startTime": 1207.784,
        "endTime": 1214.271,
        "transcript": "Tua-i-gguq tumyarailria naken iluvaqtaallri taum angutem",
        "translation": "She said that the path from where that man would appear"
    },
    "160": {
        "startTime": 1214.284,
        "endTime": 1223.496,
        "transcript": "Tumyaraulria acia-gguq tua-i imna tuaten ayuqluni, tauna taum nasaurluum acia.",
        "translation": "She said that path was like that on her bedding, that girl's bedding."
    },
    "161": {
        "startTime": 1224.689,
        "endTime": 1228.951,
        "transcript": "Aren, tua-i-gguq tauna nasaurluq inartaquq.",
        "translation": "Oh my, she said that girl lay down."
    },
    "162": {
        "startTime": 1228.964,
        "endTime": 1242.214,
        "transcript": "Tua-i-ll' inangqaluni qelemngaluni-ll' uitaqainanermini ellakegtaarni mat'um narteqertelluni tauna tua-i pugluni amigkun.",
        "translation": "Then as she stay laying with her eyes clothes, she had her [?], and he appeared through the door."
    },
    "163": {
        "startTime": 1244.083,
        "endTime": 1249.321,
        "transcript": "Amingqetullratni-gguq igcaranek, kalvagyaranek.",
        "translation": "She said it was when they had \"doors\" of tunnels that you go down."
    },
    "164": {
        "startTime": 1250.009,
        "endTime": 1257.059,
        "transcript": "Tua-i-gguq tailuni tua-i tauna im' nasaurluq aangulallrukii taum nukalpiam.",
        "translation": "She said that man that used to take care of that girl came."
    },
    "165": {
        "startTime": 1260.428,
        "endTime": 1276.028,
        "transcript": "Nutaan tua-i qasgimi tuani tuunritqatartiin taum iluguagnek malrugnek angutnguaqelriignek qasgilluteng qasgillinilriit.",
        "translation": "In the community house, the one who was going to perform the shamanistic ritual held a meeting at the community house with two [?] who were brothers."
    },
    "166": {
        "startTime": 1276.422,
        "endTime": 1286.272,
        "transcript": "Tua-i-gguq taun' tuunritestiin tuunritestii tauna arnaruamek ayagcecillruuq.",
        "translation": "She said that the one who was going to perform the ritual sent a decoy woman."
    },
    "167": {
        "startTime": 1286.279,
        "endTime": 1292.616,
        "transcript": "Taum tungiinun iluvaqtaartiin ayagcecillruuq.",
        "translation": "He sent one to the one that would appear to her."
    },
    "168": {
        "startTime": 1292.629,
        "endTime": 1302.016,
        "transcript": "Tauna-llu-gguq nasaurluq taumek angutnguamek taun' iluvaqtaalria iluircirluku.",
        "translation": "And she said that he had a decoy man replace as the one who would appear [to her]."
    },
    "169": {
        "startTime": 1302.091,
        "endTime": 1306.816,
        "transcript": "Taum nasaurluum nuniintelluku tauna angutnguq.",
        "translation": "He had that decoy man stay around that girl."
    },
    "170": {
        "startTime": 1306.897,
        "endTime": 1317.71,
        "transcript": "Tua-i qaill' taum angutem ullange'rmiu tekisngairulluku taum iluiqani angutnguam inuguam.",
        "translation": "He did it so that there was no way that man could reach her though he went to her if that decoy man, the doll, replaced him."
    },
    "171": {
        "startTime": 1318.322,
        "endTime": 1333.36,
        "transcript": "Tua-i tuaten tua-i atam nutaan tauna'urluq imna maurlurlurput assiriyartullinilria tuaten tua-i taum tuunritestellmi kinguani.",
        "translation": "Like that, you see, our poor grandmother was getting after she had that shamanistic ritual performed on her."
    },
    "172": {
        "startTime": 1333.385,
        "endTime": 1340.085,
        "transcript": "Assiriluni tua-i. Qaillun ayuqsugnairulluni tua-i ayuqellinilria.",
        "translation": "She got better. There was nothing wrong with her anymore."
    }
};